module.exports = __webpack_public_path__ + "img/40.7a739a5d.jpg";